import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";

/**
 * Fetches dashboard stats computed server-side.
 * @param {string} prefix - API endpoint prefix.
 * @param {string} orgId - Organization ID.
 * @param {object} [options] - Optional settings.
 * @param {boolean} [options.forceRefresh] - Force recomputation ignoring cache.
 * @param {AbortSignal} [options.signal] - Optional AbortSignal to cancel the request.
 * @returns {Promise<object>} - Dashboard stats object.
 */
const getDashboardStats = async (prefix, orgId, options = {}) => {
  const { forceRefresh = false, signal } = options;
  const token = await getOrRefreshFirebaseToken();
  const url = `${prefix}database/dashboard-stats`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ org_id: orgId, force_refresh: forceRefresh }),
    signal,
  });

  if (!response.ok) {
    throw new Error(`Dashboard stats failed: ${response.status}`);
  }

  return response.json();
};

export default getDashboardStats;
